import { PermanentJobsApi } from '../clients';
import { IDeleteDraftJobPayload } from '../types';

export const deleteDraftJob = async (payload: IDeleteDraftJobPayload): Promise<void> =>
  PermanentJobsApi.deleteDraftJob(payload);
